import React from "react";
import Logo from "../common/Logo";
import { CONFIG } from "../const/config";

const Footer = ({ content }) => {
  let { siteRoot, sitePaths, siteName } = CONFIG;
  return (
    <footer className="text-center space--sm footer-5 bg--dark">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <Logo />
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="heading-block">
              <ul className="list-inline list--hover">
                {content.links.map((link, i) => (
                  <li key={`footer-link-${i}`}>
                    <a
                      href={link.url}
                      {...(window.location.hostname === CONFIG.siteRoot && {
                        target: "blank",
                      })}
                    >
                      <span>{link.label}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <ul className="social-list list-inline list--hover">
                {content.social.map((link, i) => (
                  <li key={`footer-social-${i}`}>
                    <a href={link.url} target="blank">
                      <i className={`socicon ${link.icon} icon icon--xs`}></i>
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <span className="type--fine-print">
                ©<span className="update-year">{new Date().getFullYear()}</span>{" "}
                {siteName}.
              </span>
              <a
                className="type--fine-print"
                href={siteRoot + sitePaths.privacy}
                target="blank"
              >
                Privacy Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
